<template>
  <div id="app">
    <div class="app_navbar">
      <el-menu
        :default-active="$route.path"
        mode="horizontal"
        background-color="#FFFFFF"
        text-color="#000"
        active-text-color="#004DFF "
        style="margin: auto;width: 80%; font-weight: bold;"
      >
        <el-menu-item v-if="$route.meta.isShowLogo">
          <a href="http://www.pisx.com/" target="_blank"
            ><img src="./assets/img/logo/3dmodel.png" class="btn_pisx_logo"
          /></a>
        </el-menu-item>
        <el-menu-item
          v-show="$route.meta.keepAlive"
          index="/home"
          @click="HomeClik"
          >首页</el-menu-item
        >
        <!-- <el-menu-item  v-if="$route.meta.keepAlive" index="/technology" @click="TechnologyClik">全三维应用</el-menu-item> -->
        <el-menu-item
          v-if="$route.meta.keepAlive"
          index="/product"
          @click="ProductClik"
          >产品介绍</el-menu-item
        >
        <el-menu-item
          v-if="$route.meta.keepAlive"
          index="/Solution"
          @click="SolutionClik"
          >解决方案</el-menu-item
        >
        <el-menu-item
          v-if="$route.meta.keepAlive"
          index="/design"
          @click="DesignClik"
          >专业服务</el-menu-item
        >
      <!--  <div class="btn_login" v-if="$route.meta.isShowLogin">
          <button
            index="/upload"
            v-if="isloginShow"
            @click="UplodClick"
            class="btn_login_upload"
          >
            登录/上传模型
          </button>
        </div> -->
        <div class="btn_login" v-if="$route.meta.backHome">
          <button
            index="/upload"
            v-if="isloginShow"
            @click="HomeClik"
            class="btn_login_upload"
          >
            返回首页
          </button>
        </div>
      </el-menu>
    </div>
    <div class="TOPUp" @click="toTop" v-if="hidden">
      <img src="./assets/img/home/top.png" alt="" class="To_img" />
    </div>
    <!-- <div id="v-content" v-bind:style="{minHeight: Height+'px'}"></div> -->
    <div>
      <router-view v-on:FootItem="FootItem"></router-view>
    </div>
    <div v-if="footer_show">
      <foot-item></foot-item>
    </div>
  </div>
</template>

<script>
import FootItem from "./components/tabbar/Foot.vue";
window.addEventListener("beforeunload", (e) => {
  window.scroll(0, 0);
});
export default {
  name: "App",
  components: {
    FootItem
  },
  watch: {
    "$route.meta.showFooter"(value) {
      this.footer_show = value;
    }
  },
  data() {
    return {
      showModal: false,
      showRegister: false,
      footer_show: false,
      isloginShow: "",
      Height: 0,
      hidden: false
    };
  },
  mounted() {
    this.Height = document.documentElement.clientHeight - 350;
    window.onreset = () => {
      this.Height = document.documentElement.clientHeight - 350;
    };
    if (this._isMobie()) {
      //判断是手机端/平板端/ 登录入口关闭
      this.isloginShow = false;
    } else {
      //判断是PC端/ 登录入口打开
      this.isloginShow = true;
    }
    window.addEventListener("scroll", () => {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      // console.log(top);
      if (top == 0) {
        this.hidden = false;
      }
      if (top > 0) {
        this.hidden = true;
      }
    });
  },
  created() {
  this.$router.beforeEach((to, from, next) => {
    if (to.path === "/home" || to.path === "/design" || to.path === "/product"|| to.path === "/Solution") {
      this.footer_show = true;
    } else {
      this.footer_show = false;
    }
    next();
  });
},
beforeRouteUpdate(to, from, next) {
  if (to.path === "/home" || to.path === "/design"|| to.path === "/product"|| to.path === "/Solution") {
    this.footer_show = true;
  } else {
    this.footer_show = false;
  }
  next();
},
  // created() {
  // 	if (this.$router.path !== '/home') {
  // 		this.$router.replace('/home')
  // 	}
  // },
  methods: {
    _isMobie() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    HomeClik() {
      this.$router
        .push({
          path: "/home"
        })
        .catch((err) => err);
    },
    DesignClik() {
      this.$router
        .push({
          path: "/design"
        })
        .catch((err) => err);
    },
    ProductClik() {
      this.$router
        .push({
          path: "/product",
          query: { view: "adapter" }
        })
        .catch((err) => err);
    },
    SolutionClik() {
      this.$router
        .push({
          path: "/Solution"
          // query: { view: 'solution_desgin'}
        })
        .catch((err) => err);
    },
    GltfClik() {
      this.$router
        .push({
          path: "/gltf"
        })
        .catch((err) => err);
    },
    TechnologyClik() {
      this.$router
        .push({
          path: "/technology"
        })
        .catch((err) => err);
    },
    UplodClick() {
      this.showModal = true;
      // this.$router.replace('/upload');
      this.$router
        .push({
          path: "/upload"
        })
        .catch((err) => err);
    },
    login() {
      this.$axios
        .post(this.HOST + "/api/login", {
          username: this.username,
          password: this.pwd
        })
        .then((result) => {
          console.log(result.dat);
          setTimeout(function() {
            window.confirm(result.data.msg);
          }, 100);
          // this.msg = result.data.msg;
          if (result.data.status == 1) {
            this.$router
              .push({
                path: "/upload"
              })
              .catch((err) => err);
            this.showModal = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.showModal = true;
        });
    },
    register() {
      this.$axios
        .post(this.HOST + "/api/register", {
          username: this.username,
          password: this.pwd,
          email: this.email
        })
        .then((result) => {
          console.log(result.dat);
          this.msg = result.data.msg;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    RegisterShow() {
      (this.showModal = false), (this.showRegister = true);
    },
    SignShow() {
      (this.showModal = true), (this.showRegister = false);
    },
    FootItem: function(bool) {
      this.footer_show = bool;
    }
  }
};
</script>

<style scoped lang="less">
@import url("./assets/css/base.css");
@import url("../node_modules/element-ui/lib/theme-chalk/index.css");
</style>
